const TOOLS = 'tools';
const CHECKS = 'checks';
const TERMS = 'terms';
const PROCESS = 'process';

export const constants = {
  TOOLS,
  CHECKS,
  TERMS,
  PROCESS
};